// import { Workers } from "./interfaces";
import ServiceManager from "../serviceManager";
import type {
	IServiceMessage,
	IWebWorker,
	ServiceWorkers,
} from "../serviceManager/interfaces";
import { logger } from "./helpers";

export const serviceManager = new ServiceManager();

// class WebWorker creating web workers
export class WebWorker implements IWebWorker {
	public name: string;
	public worker: Worker;
	constructor(worker: Worker, name: string) {
		this.name = name;
		this.worker = worker;
	}
}

// create web workers
export const createCacheWorker = (
	name: ServiceWorkers,
	onmessage: (e: MessageEvent<IServiceMessage>) => void,
) => {
	logger.debug(`WORKERS->${createCacheWorker.name}`, `Creating worker ${name}`);
	const worker = new Worker(new URL("./Cache/index.ts", import.meta.url));
	worker.onmessage = onmessage;
	serviceManager.createService("CACHE_SYNC", worker);
	return worker;
};

// create web workers
export const createLogSyncWorker = (
	name: ServiceWorkers,
	onmessage: (e: MessageEvent<IServiceMessage>) => void,
) => {
	logger.debug(
		`WORKERS->${createLogSyncWorker.name}`,
		`Creating worker ${name}`,
	);
	const worker = new Worker(new URL("./Logger/index.ts", import.meta.url));
	worker.onmessage = onmessage;
	serviceManager.createService("LOG_SYNC", worker);
	return worker;
};

// create web workers
export const createBookingsSyncWorker = (
	name: ServiceWorkers,
	onmessage: (e: MessageEvent<IServiceMessage>) => void,
) => {
	logger.debug(
		`WORKERS->${createBookingsSyncWorker.name}`,
		`Creating worker ${name}`,
	);
	const worker = new Worker(new URL("./DataSync/index.ts", import.meta.url));
	worker.onmessage = onmessage;
	serviceManager.createService("BOOKING_DATA_SYNC", worker);
	return worker;
};

// create web workers
export const createWebSocketsWorker = (
	name: ServiceWorkers,
	onmessage: (e: MessageEvent<IServiceMessage>) => void,
) => {
	logger.debug(
		`WORKERS->${createWebSocketsWorker.name}`,
		`Creating worker ${name}`,
	);
	const worker = new Worker(new URL("./Websockets/index.ts", import.meta.url));
	worker.onmessage = onmessage;
	serviceManager.createService("WEBSOCKET_SYNC", worker);
	return worker;
};

// const workers = new WebWorkers();

// declare services on window
declare global {
	interface Window {
		services: ServiceManager;
	}
}

window.services = serviceManager;

// export default workers;
